import React from "react";
import { Row, Col, Checkbox, Typography, Select } from "antd";
import { useFormContext, Controller } from "react-hook-form";
import { useNotificationsState } from "../State";
const { Text } = Typography;
import translator from "@/translator";
const t = translator("front_office.views.altegio_notification_settings.");

const DEFAULT_BOOKING_ACTION_TYPE = 0;
const DEFAULT_CHANGED_BY = [0, 1];

export const validation = (formValues, state) => {
  const { booking_action_type, changed_by, changed_params } = formValues;
  const {
    booking_actions: { extra_options },
  } = state;

  const validExtraOptions = extra_options[booking_action_type] || {};
  const validChangedByOptions = validExtraOptions.changed_by || [];
  const validChangedParamsOptions = validExtraOptions.changed_params || [];

  const isChangedByValid =
    validChangedByOptions.length === 0 || (Array.isArray(changed_by) && changed_by.length > 0);

  const isChangedParamsValid =
    validChangedParamsOptions.length === 0 ||
    (Array.isArray(changed_params) && changed_params.length > 0);

  return isChangedByValid && isChangedParamsValid;
};

const CheckboxGroup = ({ options, value, onChange }) => {
  return <Checkbox.Group options={options} value={value} onChange={onChange} />;
};

const BookingActions = () => {
  const { watch, control } = useFormContext();
  const { state } = useNotificationsState();

  const selectedBookingActionType = watch("booking_action_type", DEFAULT_BOOKING_ACTION_TYPE);

  const bookingActionOptions = state.booking_actions.options || [];

  if (bookingActionOptions.length === 0) {
    return null;
  }

  const bookingActionExtraOptions =
    state.booking_actions.extra_options[selectedBookingActionType] || {};

  const changedByOptions = bookingActionExtraOptions.changed_by || [];
  const changedParamsOptions = bookingActionExtraOptions.changed_params || [];

  return (
    <Row gutter={[0, 16]}>
      <Col sm={24} xl={11}>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Text strong>{t("fields.booking_actions.title")}</Text>
          </Col>
          <Col span={24}>
            <Text className="altegio-notification-settings-create__helper-text">
              {t("fields.booking_actions.subtitle")}
            </Text>
          </Col>
        </Row>
      </Col>
      <Col sm={0} xl={2} />
      <Col sm={24} xl={11}>
        <Col span={24}>
          <Controller
            control={control}
            name="booking_action_type"
            defaultValue={DEFAULT_BOOKING_ACTION_TYPE}
            render={({ field: { onChange, value } }) => (
              <Select
                value={value}
                onChange={onChange}
                size="large"
                className="ant-custom-select"
                popupClassName="ant-custom-select-dropdown"
                style={{ width: "100%" }}
                options={bookingActionOptions}
              />
            )}
          />
        </Col>

        {(changedByOptions.length != 0 || changedParamsOptions.length != 0) && (
          <Col span={24} className="altegio-notification-settings-create__adv-settings-group">
            {changedByOptions.length != 0 && (
              <div className="altegio-notification-settings-create__booking_actions-i">
                {t("fields.booking_actions.changed_by")}
                <Controller
                  control={control}
                  name="changed_by"
                  defaultValue={DEFAULT_CHANGED_BY}
                  render={({ field: { onChange, value } }) => (
                    <CheckboxGroup value={value} onChange={onChange} options={changedByOptions} />
                  )}
                />
              </div>
            )}
            {changedParamsOptions.length != 0 && (
              <div className="altegio-notification-settings-create__booking_actions-i">
                {t("fields.booking_actions.changed_params")}
                <Controller
                  control={control}
                  name="changed_params"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CheckboxGroup
                      value={value}
                      onChange={onChange}
                      options={changedParamsOptions}
                    />
                  )}
                />
              </div>
            )}
          </Col>
        )}
      </Col>
    </Row>
  );
};

export default BookingActions;
